import { render } from "./BlockProgressEdit.vue?vue&type=template&id=7cc7f07c"
import script from "./BlockProgressEdit.vue?vue&type=script&lang=js"
export * from "./BlockProgressEdit.vue?vue&type=script&lang=js"
script.render = render

export default script